/**
 * AuthShell — the centered card chrome for unauthenticated / step-up pages
 * (login, password reset, MFA enroll, MFA verify).
 */
import React from 'react';

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base dark:bg-surface-dark-base p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-continuum-500 text-white text-xl font-semibold shadow-thin mb-3">
            CX
          </div>
          <h1 className="text-xl font-semibold text-surface-text dark:text-surface-dark-text">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-surface-muted dark:text-surface-dark-muted">{subtitle}</p>
          )}
        </div>
        <div className="rounded-thin bg-surface-panel dark:bg-surface-dark-panel border border-surface-border dark:border-surface-dark-border shadow-thin-lg p-6">
          {children}
        </div>
        {footer && (
          <div className="mt-4 text-center text-xs text-surface-muted dark:text-surface-dark-muted">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

// --- Re-usable thin form primitives -------------------------------------

export function Label({ children, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="block text-sm font-medium text-surface-text dark:text-surface-dark-text mb-1">
      {children}
    </label>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={
        'w-full px-3 py-2 rounded-thin bg-surface-base dark:bg-surface-dark-base ' +
        'border border-surface-border dark:border-surface-dark-border ' +
        'text-surface-text dark:text-surface-dark-text ' +
        'placeholder:text-surface-muted dark:placeholder:text-surface-dark-muted ' +
        'focus:border-continuum-500 focus:ring-1 focus:ring-continuum-500 outline-none ' +
        'transition-colors ' +
        (props.className || '')
      }
    />
  );
}

export function PrimaryButton({ children, loading, ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={
        'w-full px-4 py-2.5 rounded-thin font-medium text-white ' +
        'bg-continuum-500 hover:bg-continuum-600 active:bg-continuum-700 ' +
        'disabled:bg-continuum-300 disabled:cursor-not-allowed ' +
        'shadow-thin transition-colors ' +
        (props.className || '')
      }
    >
      {loading ? '…' : children}
    </button>
  );
}

export function ErrorBanner({ children }) {
  if (!children) return null;
  return (
    <div className="mb-4 px-3 py-2 rounded-thin bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-sm text-red-700 dark:text-red-200">
      {children}
    </div>
  );
}
